import { useTranslation } from "react-i18next";

export default function UpperPart(props){
  const {t} = useTranslation();
  const index = props.index;
  const reverse = props.reverse!==undefined ? "-reverse":"";

  return (
    <div className={`flex flex-col lg:flex-row${reverse} lg:mb-20 lg:items-center`}>
      <div className={`lg:mr-10 ${props.reverse!==undefined? "lg:ml-10":""} my-10`}>
        <p className="mb-6 text-xl lg:text-2xl lg:font-semibold">{t(`business.overview.title-${index}`)}</p>
        <p className="mb-6 text-lg font-thin text-gray-800 lg:text-3xl/9" 
          dangerouslySetInnerHTML={{__html:t(`business.overview.sub-title-${index}`)}}></p>
        <p className="text-xs font-light text-gray-500 lg:text-base">{t(`business.overview.comment-${index}`)}</p>
      </div>
      <img src={require(`assets/images/solutions/business/business_${index}.jpg`)} 
        alt='development business concept'
        className="lg:w-[520px]"/>
    </div>
  );
}